import React from "react";
import styled from "styled-components";
import CandybarGridItem from "../../checkout/Candybar/CandybarGridItem";
import CatalogBlockGrid from "./CatalogBlockGrid";

const Block = styled.div`
    margin-bottom: 2em;
`;

function CatalogBlocks({blocks, items, actions, RenderItem, alwaysShowTitle = false}) {
    return blocks.map(block => {
        const blockItems = items.filter(item => item.blocks.indexOf(block.id) > -1);

        if (!blockItems.length && !block.emptyMessage) return '';

        return <Block key={block.id}>
            <h2 className="title-2 catalog-block-title">{block.name}</h2>
            {blockItems.length ? <CatalogBlockGrid items={blockItems} actions={actions} RenderItem={RenderItem}/> : <p>{block.emptyMessage}</p>}
        </Block>;
    });
}

export default CatalogBlocks;